import { render, staticRenderFns } from "./WellInfo.vue?vue&type=template&id=84393da8&scoped=true&"
import script from "./WellInfo.vue?vue&type=script&lang=js&"
export * from "./WellInfo.vue?vue&type=script&lang=js&"
import style0 from "./WellInfo.vue?vue&type=style&index=0&id=84393da8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84393da8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCalendar } from 'vuetify/lib/components/VCalendar';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
installComponents(component, {VBtn,VCalendar,VForm,VIcon,VList,VListItem,VListItemContent,VListItemIcon})
